import React, {useState, useEffect, CSSProperties} from 'react';

import './../modalNewQuestion.scss'
import EditorService from 'app_services/editor/editorService';
import { TypeQuestionsCategoriesEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import { MdClose } from 'react-icons/md';
import { Spinner } from 'react-bootstrap';
import IconComponent from 'app_components/commons/icons';
import shortId from 'shortid';
import { ICreateQuestionQuery } from 'app_services/editor/questions/questionsService';
import storeService from 'app_services/storeService';
import { useQuery } from 'app_hooks/useQuery';
import QuestionsService from 'app_services/editor/questions/questionsService';
import { useTranslation } from 'react-i18next';

interface IOptionsCreateResource{
    icon: string
    name: string
    active: boolean
    id: string
    type: TypeQuestionsCategoriesEditor
}

interface IModalNewQuestionLayoutProps {
    open: boolean
    inputData?: any
    disableModal?: boolean
    createWithClick?: boolean
    className?: string
    style?: CSSProperties
    only?: TypeQuestionsCategoriesEditor[]
    handleClose: (data?: any)=>void
}

const ModalNewQuestionLayout: React.FC<IModalNewQuestionLayoutProps> = (props) => {

    const [optionSelected, updateOptionSelected] = useState<IOptionsCreateResource | undefined>(undefined)
    const [loading, updateLoading] = useState(false)
    const {t} = useTranslation()
    const {query} = useQuery()

    // Servicios
    const questionsService = new QuestionsService()

    const [options, updateOptions] = useState<IOptionsCreateResource[]>([
        {type: 'multiple-choice-unique-answer' ,id:shortId.generate() ,icon: 'OneSelection', name: t('editor.resources.exercise.create_question.unique_choice'), active: false},
        {type: 'multiple-choice-multiple-answer' ,id:shortId.generate() ,icon: 'MultipleSelection', name: t('editor.resources.exercise.create_question.multiple_choice'), active: false},
        // {type: 'fill-in-spaces' ,id:shortId.generate() ,icon: 'FillInSpaces', name: t('editor.resources.exercise.create_question.fill_in_spaces'), active: false},
        // {type: 'relate-items' ,id:shortId.generate() ,icon: 'MatchQuestion', name: t('editor.resources.exercise.create_question.relate_columns'), active: false},
        {type: 'open-answer' ,id:shortId.generate() ,icon: 'OpenQuestion', name: t('editor.resources.exercise.create_question.open'), active: false},
        {type: 'select-range' ,id:shortId.generate() ,icon: 'FillInSpaces', name: t('editor.resources.exercise.create_question.select_range'), active: false},
    ])

    /**
     * @INFO Actualizar el valor de las opciones
     */
    useEffect(() => {
      const newOptions = getOptions()
      updateOptions([...newOptions])
    },[props.only])

    /**
     * @INFO Dejar por defecto ningún tipo seleccionado
     */
    useEffect(() => {
        const optionsAux = [...getOptions()]
        optionsAux.forEach((item, i) => {
            optionsAux[i].active = false
        })
        updateLoading(false)
        updateOptions([...optionsAux])
        updateOptionSelected(undefined)
    }, [props.open])

    /**
     * @INFO Obtener opciones
     * @returns
     */
    const getOptions = () => {
      if(props.only?.length){
        const newOptions = props.only.reduce((accum: IOptionsCreateResource[], item) => {
          const aux = options.find((item2) => item2.type === item)
          if(aux){
            accum.push(aux)
          }
          return accum
        },[])
        return [...newOptions]
      }else{
        return [...options]
      }
    }

    /**
     * @INFO Click al seleccionar un tipo
     * @param id
     */
    const handleClickTypeOption = (idx: number) => {
        const optionsAux = [...options]
        optionsAux.forEach((item, i) => {
            optionsAux[i].active = false
        })
        optionsAux[idx].active = true
        updateOptionSelected({...optionsAux[idx]})
        updateOptions([...optionsAux])
        if(props.createWithClick){
          handleClickCreate({...optionsAux[idx]})
        }
    }

    /**
     * @INFO Click en crear pregunta
     */
    const handleClickCreate = async (_option?: IOptionsCreateResource) => {
        const status = await questionsService.validateChangeQuestion()
        if(!status) return
        let parent: string | undefined =  undefined
        let auxOption = {...optionSelected}
        if(_option){
          auxOption = {..._option}
        }
        if(props.inputData && props.inputData.parent){
            parent = props.inputData.parent
        }
        if(auxOption && auxOption.type){
            updateLoading(true)
            const params: ICreateQuestionQuery = {
                content: 'Sin titulo',
                question_category: storeService?.getQuestionCategoryFromName(auxOption.type) as string,
                parent
            }
            switch(auxOption?.type){
                case 'multiple-choice-multiple-answer':
                    params.value = 10
                    params.answers = [
                        {content: 'Opción 1', is_correct: false, value: 0},
                        {content: 'Opción 2', is_correct: true, value: 10},
                    ]
                    break;
                case 'multiple-choice-unique-answer':
                    params.value = 10
                    params.answers = [
                        {content: 'Opción 1', is_correct: false, value: 0},
                        {content: 'Opción 2', is_correct: true, value: 10},
                    ]
                    break;
                case 'container':
                    break;
                case 'open-answer':
                    params.value=10
                    break;
                case 'select-range':
                    params.value=10
                    break;
                default:
                    break;
            }
            const response = await questionsService.createQuestion(params)
            if(response && response.code === 200){
                props.handleClose(response.question)
                updateLoading(false)
            }
        }
    }

    return (
        props.open || props.disableModal?
            <>
                <div
                  className={`modal_new_question-component ${props.disableModal ? '' : 'modal'} ${props.className ? props.className : ''}`}
                  style={props.style}
                >
                    <div className='container-body-new-resource'>
                        {loading ? <div className='container-loading'><Spinner animation='border' className='icon-loading' /> </div> :null}
                        {!props.disableModal ?
                          <>
                            <MdClose onClick={() => props.handleClose(undefined)} className='close-icon' />
                            <p className='title-new-resource'>{t('editor.resources.exercise.create_question.title')}</p>
                          </>
                        :null}
                        <div>
                            {options.map((item, idx) => (
                                <div key={item.id} onClick={()=>handleClickTypeOption(idx)} className={`container-option ${item.active ? 'container-option-active' : ''}`}>
                                    <p>{item.name}</p>
                                    <IconComponent class_name='icon-new-resource' svg={item.icon} />
                                </div>
                            ))}
                        </div>
                        {!props.createWithClick ?
                          <div className='container-button-create'>
                              <button className='btn btn-primary btn-create' disabled={!optionSelected || loading} onClick={()=>handleClickCreate()} >{t('editor.resources.exercise.create')}</button>
                          </div>
                        : null}
                    </div>
                </div>
            </>
        : null
    );
};

export default ModalNewQuestionLayout;
